import React from 'react'
import { useTranslation } from 'react-i18next'
import { ContentCheckProofStatus, ReportStatus } from 'generated/types'
import {
	getProcessStatusColor,
	StatusCellWrapper,
	StatusDot,
	StatusText
} from '../styles'

/**
 * Props passed to the status cell to render a colored dot and localized status text.
 */
export type StatusCellProps = {
	status: ReportStatus | ContentCheckProofStatus
}

/**
 * Renders a status indicator with a colored dot and translated label.
 *
 * Uses `getProcessStatusColor` to map status to a theme color and i18n keys
 * `approval.processStatus.<status>` for localized text.
 */
const StatusCell: React.FC<StatusCellProps> = ({ status }) => {
	const [t] = useTranslation()
	const color = getProcessStatusColor(status)
	return (
		<StatusCellWrapper>
			<StatusDot color={color} />
			<StatusText>{`${t(`approval.processStatus.${status}`)}`}</StatusText>
		</StatusCellWrapper>
	)
}

export default StatusCell
